import React, { useEffect, useMemo } from 'react';

import { useAppDispatch } from '../../../hooks/react-redux';
import { useWindowResize } from '../../../hooks/useWindowResize';
import { NettingEngineResults } from './NettingEngineResults';
import { NettingResponseData, resetEngineDataState } from './store';
import { NAV_BAR } from '../../../hooks/useSplitView';

const WIDTH_OFFSET = 40;
const HEIGHT_OFFSET = NAV_BAR;

interface NettingEngineResultsWrapperProps {
    results: NettingResponseData;
}

export const NettingEngineResultsWrapper: React.FC<NettingEngineResultsWrapperProps> = ({ results }) => {
    const dispatch = useAppDispatch();
    const [screenWidth, screenHeight] = useWindowResize();
    const width = useMemo(() => screenWidth - WIDTH_OFFSET, [screenWidth]);
    const height = useMemo(() => screenHeight - HEIGHT_OFFSET, [screenHeight]);

    useEffect(() => () => {
        dispatch(resetEngineDataState());
    }, [dispatch]);

    return (
        <NettingEngineResults
            results={results}
            height={height}
            width={width}
        />
    );
};
